module.exports = __webpack_public_path__ + "img/awards_image_21.bdd5ba7d.jpg";